import { Box, FormControl } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import UpdatedBadge from "./UpdatedBadge";
import styled from "styled-components";
import useTheme from "../../../../common/hooks/useTheme";
import { RootStateAnswers } from "../../../questionnaire/store/answers-slice";
import { personalInfoType } from "../../store/helper";

const StyledInputLabel = styled.label<{ theme: any }>`
  position: absolute;
  left: 0;
  top: 0;
  font-family: var(--font-Medium), sans-serif;
  font-size: 10px;
  color: ${({ theme }) => theme.colors_ds.NEUTRAL_TEXT_WEAK};
  pointer-events: none;
  transition: transform 0.2s ease-in-out;
  transform: translate(12px, 10px) scale(1);
  z-index: 1;
  background-color: transparent;
`;

const StyledOutlinedInput = styled.div<{ theme: any }>`
  width: 100%;
  height: 56px;
  padding: 24px 0 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors_ds.NEUTRAL_BORDER_WEAK};
  border-radius: 8px;
  font-family: var(--font-Medium), sans-serif;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors_ds.NEUTRAL_TEXT_DEFAULT};
  background-color: ${({ theme }) => theme.colorTokens.N[20]};
  cursor: not-allowed;
  box-sizing: border-box;
`;

interface ReadOnlyInputFieldProps {
  category: string;
  label?: string;
}

const ReadOnlyInputField: React.FC<ReadOnlyInputFieldProps> = ({
  category,
  label,
}) => {
  const theme = useTheme();
  const answers = useSelector((state: RootStateAnswers) => state.answers);

  const handleLabel = (cat: string): string => {
    if (label) return label;
    if (cat === personalInfoType.email) {
      return "Email account";
    }
    return "";
  };

  const handleValue = (cat: string): string => {
    return answers.personalInfoAnswers[cat] ?? "";
  };

  const curLabel = handleLabel(category);
  const curValue = handleValue(category);

  return (
    <Box
      component="div"
      sx={{
        width: "100%",
      }}
    >
      <FormControl
        variant="outlined"
        fullWidth
        sx={{
          position: "relative",
        }}
      >
        <StyledInputLabel theme={theme}>
          {curLabel}
          {answers.personalInfoModifiedFields.indexOf(category) !== -1 && (
            <UpdatedBadge />
          )}
        </StyledInputLabel>
        <StyledOutlinedInput theme={theme}>{curValue}</StyledOutlinedInput>
      </FormControl>
    </Box>
  );
};

export default ReadOnlyInputField;
